module.exports = __webpack_public_path__ + "static/media/Reglas-de-origen-aplicadas-en-los-tratados-comerciales.d3aad0c6.pdf";